import { putApi } from "./api_instance";

export const viewCurrentNotification = async (dispatch, id) => {
  try {
    // console.log(id)
    const { data } = putApi({
      apiUrl: `/admin/projects/api/notification/status/${id}`,
      dispatch,
      sendToken: true,
      data: {},
    });
    return data;
  } catch (error) {
    throw error;
  }
};
